import { useState, useEffect } from "react"
import { MainWrapper } from "../../common/MainWrapper"
import { StyledMainTitle } from "../styled"
import { Link, useNavigate } from "react-router-dom"
import Header from "../../common/Header"

const Archives = ({ user }) => {
  const [auth, setAuth] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    const auth = localStorage.getItem("UserName")
    setAuth(auth)
    if (user === "true") {
      navigate("/archiwum")
    }
  }, [user, navigate])

  return (
    <>
      <Header user={user} />
      <MainWrapper>
        <StyledMainTitle>Archiwum</StyledMainTitle>
        <h5 className="text-primary m-2">Cześć {auth}</h5>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <Link
              to="/archinsday"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Wprowadź dzień pracy
            </Link>

            <Link
              to="/archalldays"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż listę wszystkich dni
            </Link>

            <Link
              to="/archresult"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż zarobki
            </Link>

            <Link
              to="/archstatments"
              className="col-md-2 btn btn-primary btn-lg m-2 p-3"
              role="button"
            >
              Pokaż zestawienia
            </Link>

            
          </div>
        </div>
      </MainWrapper>
    </>
  );
}

export default Archives
